import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface CurrentDateAndTimeProps {}

const CurrentDateAndTime = (props: CurrentDateAndTimeProps) => {
  const [currentDateTime, setCurrentDateTime] = useState<Date>(new Date());
  const { t } = useTranslation();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formattedDate = currentDateTime.toLocaleDateString();
  const formattedTime = currentDateTime.toLocaleTimeString();

  return (
    <div>
      <b>{t("currentDateAndTime")}:</b>
      <div>
        {formattedDate}, {formattedTime}
      </div>
    </div>
  );
};

export default CurrentDateAndTime;
